import { render, staticRenderFns } from "./roomLogDetails.vue?vue&type=template&id=32b79f0e&scoped=true&"
import script from "./roomLogDetails.vue?vue&type=script&lang=js&"
export * from "./roomLogDetails.vue?vue&type=script&lang=js&"
import style0 from "./roomLogDetails.vue?vue&type=style&index=0&id=32b79f0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b79f0e",
  null
  
)

export default component.exports